import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  TextInput,
  KeyboardAvoidingView,
  Platform,
  Image,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { avatarColorForName, getBannerDetailImage } from '../../data/promoSocialDemo';

function initials(name) {
  const parts = String(name || '?').trim().split(' ');
  return (parts[0]?.[0] || '?').toUpperCase();
}

function Avatar({ name, uri }) {
  if (uri) {
    return <Image source={{ uri }} style={styles.avatar} />;
  }
  return (
    <View style={[styles.avatar, { backgroundColor: avatarColorForName(name) }]}>
      <Text style={styles.avatarText}>{initials(name)}</Text>
    </View>
  );
}

function LikeRow({ user, avatar }) {
  return (
    <View style={styles.likeRow}>
      <Avatar name={user} uri={avatar} />
      <View style={styles.likeBody}>
        <Text style={styles.likeText}>
          <Text style={styles.likeUser}>{user} </Text>
        </Text>
      </View>
    </View>
  );
}

export default function PromoLikeSheet({
  visible,
  likes,
  onClose,
}) {
  return (
    <Modal visible={visible} transparent animationType="slide" onRequestClose={onClose}>
      <KeyboardAvoidingView
        style={styles.viewport}
        behavior={Platform.OS === 'ios' ? 'padding' : undefined}
        pointerEvents="box-none"
      >
        <TouchableOpacity style={styles.outside} activeOpacity={1} onPress={onClose} />
        <View style={styles.column} pointerEvents="box-none">
          <TouchableOpacity style={styles.backdrop} activeOpacity={1} onPress={onClose} />
          <View style={styles.sheet}>
            <View style={styles.handle} />
            
            <View style={styles.header}>
              <Text style={styles.headerTitle}>Likes</Text>
              <TouchableOpacity onPress={onClose} hitSlop={10} style={styles.closeBtn}>
                <Ionicons name="close" size={20} color="#0F172A" />
              </TouchableOpacity>
            </View>

            <ScrollView
              style={styles.list}
              contentContainerStyle={styles.listContent}
              keyboardShouldPersistTaps="handled"
            >
              {(likes || []).length === 0 ? (
                <Text style={styles.empty}>Belum ada like</Text>
              ) : (
                (likes || []).map((like) => (
                  <View key={like.id}>
                    <LikeRow user={like.user} avatar={like.avatar} />
                  </View>
                ))
              )}
            </ScrollView>

          </View>
        </View>
      </KeyboardAvoidingView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  viewport: {
    flex: 1,
    alignItems: 'center',
  },
  outside: {
    ...StyleSheet.absoluteFillObject,
  },
  column: {
    width: '100%',
    maxWidth: 430,
    height: '100%',
    justifyContent: 'flex-end',
  },
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.45)',
  },
  sheet: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    maxHeight: '88%',
    minHeight: 420,
    paddingBottom: Platform.OS === 'ios' ? 24 : 12,
    zIndex: 2,
  },
  handle: {
    alignSelf: 'center',
    width: 36,
    height: 4,
    borderRadius: 2,
    backgroundColor: '#E2E8F0',
    marginTop: 8,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: '#E2E8F0',
  },
  headerTitle: {
    fontSize: 16,
    fontFamily: 'Poppins-SemiBold',
    fontWeight: '600',
    color: '#0F172A',
  },
  closeBtn: {
    position: 'absolute',
    right: 16,
  },
  list: {
    flexGrow: 1,
  },
  listContent: {
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  postBlock: {
    marginBottom: 16,
  },
  postImage: {
    width: '100%',
    aspectRatio: 4 / 5,
    borderRadius: 8,
    backgroundColor: '#E2E8F0',
    marginBottom: 10,
  },
  postCaption: {
    fontSize: 13,
    fontFamily: 'Poppins',
    color: '#0F172A',
    lineHeight: 18,
    marginBottom: 8,
  },
  empty: {
    textAlign: 'center',
    color: '#94A3B8',
    fontFamily: 'Poppins',
    fontSize: 13,
    paddingVertical: 32,
  },
  likeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontFamily: 'Poppins-SemiBold',
    fontWeight: '600',
  },
  likeBody: {
    flex: 1,
  },
  likeText: {
    fontSize: 13,
    fontFamily: 'Poppins',
    color: '#0F172A',
    lineHeight: 18,
  },
  likeUser: {
    fontFamily: 'Poppins-SemiBold',
    fontWeight: '600',
  },
});
